import { render, staticRenderFns } from "./W-9-Cert.vue?vue&type=template&id=76ae25b4&"
import script from "./W-9-Cert.vue?vue&type=script&lang=js&"
export * from "./W-9-Cert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports